// src/components/SeatIndicator.tsx
import 'media/css/SeatIndicator.scss'; // File CSS để tạo kiểu cho component
// Định nghĩa các props mà component sẽ nhận
interface SeatIndicatorProps {
  /** Tổng số ghế (tổng số ô vuông) */
  totalSeats: number;
  /** Số ghế đã được đặt (số ô vuông được tô màu) */
  occupiedSeats: number;
  /** Kích thước của mỗi ô vuông (tùy chọn) */
  size?: number;
  /** Màu cho ghế còn trống (tùy chọn) */
  availableColor?: string;
  /** Màu cho ghế đã đặt (tùy chọn) */
  occupiedColor?: string;
  /** Màu khi có lỗi (số ghế đặt > tổng số ghế) */
  errorColor?: string;
  /** Hiển thị thêm thông tin hay không */
  showHint?: boolean;
}

export default function SeatIndicator({
  totalSeats,
  occupiedSeats,
  size = 16, // Kích thước mặc định là 16px
  availableColor = '#e0e0e0', // Màu xám nhạt cho ghế trống
  occupiedColor = '#4caf50', // Màu xanh cho ghế đã đặt
  errorColor = '#f44336', // Màu đỏ cho trạng thái lỗi
  showHint = false,
}: SeatIndicatorProps) {
  // Kiểm tra trạng thái lỗi: số ghế đã đặt vượt quá tổng số ghế
  const isErrorState = occupiedSeats > totalSeats;

  // Tạo một mảng các ô vuông để render
  const seats = Array.from({ length: totalSeats }, (_, index) => {
    // Nếu không lỗi, áp dụng logic cũ
    const isOccupied = !isErrorState && index < occupiedSeats;

    // Xác định màu nền cho ô
    const backgroundColor = isErrorState
      ? errorColor // Ưu tiên màu lỗi nếu có
      : isOccupied
        ? occupiedColor
        : availableColor;

    // Xác định nội dung cho tooltip (thuộc tính title)
    const title = isErrorState
      ? `Lỗi: Số ghế đã đặt (${occupiedSeats}) vượt quá tổng số ghế (${totalSeats})`
      : isOccupied
        ? 'Ghế đã đặt'
        : 'Ghế còn trống';

    return (
      <div
        key={index}
        className="seat-box"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: backgroundColor,
        }}
        title={title}
      />
    );
  });

  return (
    <div className="seat-indicator-container">
      <div className="seats-wrapper">{seats}</div>
      <div className="seats-legend">{showHint && `${occupiedSeats} / ${totalSeats}`}</div>
    </div>
  );
}

